var exports = {
  "v": "dialogBody__XofsFP",
};

module.exports = exports;
